import Answer from './answer';
export default Answer;
